// extracted by mini-css-extract-plugin
export var active = "_m-9";
export var backButton = "_m-8";
export var clone = "_m-e";
export var collapseBar = "_m-k";
export var collapseMode = "_m-m";
export var collapsed = "_m-o";
export var dimmed = "_m-i";
export var dragHandle = "_m-c";
export var dropdownIcon = "_m-g";
export var expanding = "_m-n";
export var hidden = "_m-x";
export var iconContainer = "_m-q";
export var iconSwapper = "_m-w";
export var navItem = "_m-6";
export var navItemIcon = "_m-f";
export var navProfile = "_m-7";
export var notificationCountBadge = "_m-j";
export var notificationDot = "_m-r";
export var optionsContainer = "_m-h";
export var primaryNav = "_m-0";
export var primaryNavDivider = "_m-v";
export var primaryNavResizeHandle = "_m-2";
export var primaryNavResizing = "_m-1";
export var primaryNavTabSection = "_m-u";
export var primaryTab = "_m-p";
export var primaryTabIconBox = "_m-s";
export var secondaryNav = "_m-3";
export var selected = "_m-t";
export var settingsNav = "_m-4";
export var settingsNavItems = "_m-5";
export var show = "_m-d";
export var sideNav = "_m-l";
export var teamItem = "_m-a";
export var userProfileItem = "_m-b";